import React from 'react';
import { useWatch } from 'react-hook-form';
import { DateField, InputField } from 'vetrf-ui';
import { ProductType } from 'components/registry/types/api';
import { BYTE_MAX_LENGTH } from 'utils/consts/consts';
import { EntryRegistrationDTO } from 'api/entryRegistration/types';

type FormFieldsProps = {
  productType: ProductType;
  defaultValues?: EntryRegistrationDTO;
};

export const FormFields = ({ productType, defaultValues }: FormFieldsProps) => {
  const startValidityDateValue = useWatch({ name: 'startValidityDate' });

  return (
    <>
      {(productType === ProductType.feed ||
        (productType === ProductType.gmProduct && !!defaultValues?.series)) && (
        <InputField labelText="Учётная серия №" name="series" maxLength={BYTE_MAX_LENGTH} />
      )}
      <InputField
        labelText="Регистрационный №"
        name="regNumber"
        required="Необходимо заполнить поле"
        maxLength={BYTE_MAX_LENGTH}
      />
      <DateField
        dateFormat="dd.MM.yyyy"
        labelText="Дата начала срока действия"
        locale="ru"
        name="startValidityDate"
        required={productType === ProductType.feed && 'Необходимо заполнить поле'}
        validateDateFormat
      />
      <DateField
        dateFormat="dd.MM.yyyy"
        labelText="Дата окончания срока действия"
        locale="ru"
        name="endValidityDate"
        validateDateFormat
        comparisonWithAnotherDate={{
          methodOfComparison: 'isSameOrAfter',
          value: startValidityDateValue,
        }}
      />
    </>
  );
};
